import React, { Component } from 'react';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'

import { Request } from "./../../SYSTEM/Request"

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';
import Loader from './../../APP/COMPONENTS/Loader';

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class Orders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            USER: this.props.USER,
            LOADED: false,
            ORDERS: []
        }
    }


    componentDidMount = () => {
        this.fetchOrders()
    }


    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.USER !== prevProps.USER) {
            this.setState({ USER: this.props.USER });
        }
    }

    fetchOrders = async () => {
        try {
            let SEND_DATA = {};

            let data = await Request(SEND_DATA, 'incomings/listing');
            if (data !== false) {
                this.setState({ ORDERS: data, LOADED: true });
            } else {
                this.setState({ LOADED: true });
            }
        } catch (error) {
        }
    }

    renderFiter = () => {
        return null
    }

    filterOrders = () => {
        let ORDERS = this.state.ORDERS
        let FILTERED_ORDERS = ORDERS

        return FILTERED_ORDERS
    }

    renderStatusBadge = (status) => {
        let title = 'Новый';
        let className = 'new';

        switch (parseInt(status)) {
            case 1:
                title = 'На согласовании';
                className = 'talk';
                break;
            case 2:
                title = 'Ожидание поставки';
                className = 'waiting';
                break;
            case 3:
                title = 'Отменён';
                className = 'cancelled';
                break;
            case 4:
                title = 'Принимается';
                className = 'done';
                break;
            case 5:
                title = 'Принят';
                className = 'done';
                break;
        }

        return <span className={ 'order_status ' + className }>{ title }</span>
    }

    renderOrdersRows = (ORDERS, SAVEABLE) => {
        let ROWS = [];
        for (let i = 0; i < ORDERS.length; i++) {
            let ORDER = ORDERS[i];

            ROWS.push(
                <tr key={ i }>
                    <td>{ this.renderStatusBadge(ORDER.status) }</td>
                    <td>{ ORDER.id }</td>
                    <td className="cell-center">{ ORDER.ru_created }</td>
                    <td className="cell-center">{ ORDER.ru_planned }</td>
                    <td className="cell-center">{ ORDER.sum } руб</td>
                    <td><Link to={ "/orders/" + ORDER.id } className="my_own_price">перейти</Link></td>
                </tr>
            );
        }

        return (
            <tbody>
                { ROWS }
            </tbody>
        );
    }

    renderOrdersTableHeader = () => {
        return (
            <thead>
                <tr>
                    <th>статус</th>
                    <th>номер</th>
                    <th>дата заказа</th>
                    <th>дата поставки</th>
                    <th>сумма</th>
                    <th></th>
                </tr>
            </thead>
        );
    }

    renderOrders = () => {
        if (this.state.LOADED) {
            if (this.state.ORDERS.length) {
                let ORDERS = this.filterOrders();
                let TBODY = this.renderOrdersRows(ORDERS);
                let HEADER = this.renderOrdersTableHeader();

                return (
                    <div className="table_holder">
                        <table id="products_table" className="products_table" cellPadding="0" cellSpacing="0">
                            { HEADER }
                            { TBODY }
                        </table>
                    </div>
                );

            } else {
                return <div className="table_holder"><h3>Мы не нашли ваших заказов в базе</h3></div>;
            }
        } else {
            return <div className="table_holder"><Loader /><div className="loader_content">Собираем статистику по заказам ...</div></div>
        }
    }

    render() {
        if (!this.state.USER) {
            return <Redirect to="/" />
        }

        return (
            <div className="main_content">
                <Helmet>
                    <title>Заказы</title>
                </Helmet>
                <h1>Заказы</h1>
                { this.state.USER.selforder == 1 ?
                    <Link className="filter_btn" style={ { marginBottom: '10px' } } to="/products">Новый заказ</Link>
                    : null }
                { this.renderFiter() }
                { this.renderOrders() }
            </div>
        );
    }
}

export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(Orders))
